import React from "react";
import "./sidebar-toggle-button.css";
import useCookies from "./../../hooks/useCookies";


const SidebarToggle = (props) => {
  const {
    setContentDrawerInteractionCookie
  } = useCookies();
  const sidetitle = props.sideDrawerTitle
  const textColor = props.sidebarBtnTextColor
  const sessionTimeoutValue = props.drawerSessionTimeoutValue
  const sessionType = props.drawerSessionType
  const bgColor = props.drawerBgColor
  const defaultBgColor = props.defaultBgColor
  return (
    <div className="sidebar-button">
      <span
        onClick={()=>{
            props.sidebarToggle()
            if(!(sessionTimeoutValue === '' && (sessionType === 'static' || sessionType === ''))){
              setContentDrawerInteractionCookie()
              //console.log('intraction set')
            }
        }}
        className="sidebar-toggle text-nowrap"
        style={{
          backgroundColor: `${
            bgColor !== ""
              ? bgColor
              : defaultBgColor
          }`,
          color : `${textColor}`
        }}
      >
        {sidetitle}
      </span>
    </div>
  );
};

export default SidebarToggle;
